import React from 'react';
import { Stack, Box } from '@mui/material';
import { RadioGroupContextProvider } from './context';
import { useMixedValue } from '../../hooks/useMixedValue';
import { useUniqueId } from '../../hooks/useUniqueId';
import Radio from './index';
const isRadioElement = (element) => element.type === Radio;
const resetChildrenStatus = (children, value) => {
    const list = React.Children.toArray(children).filter((child) => React.isValidElement(child));
    let focusItemIndex = 0;
    for (let i = 0; i < list.length; i++) {
        if (isRadioElement(list[i]) && list[i].props.value === value) {
            focusItemIndex = i;
            break;
        }
    }
    const radioList = list.map((item, index) => React.cloneElement(item, {
        ...(isRadioElement(item)
            ? {
                tabIndex: focusItemIndex === index ? 0 : -1,
            }
            : {}),
    }));
    return radioList;
};
const RadioGroup = React.forwardRef((props, ref) => {
    const { disabled, name: groupName, children, defaultValue, value: constantValue, onChange, role = 'radiogroup', inline = false, ...others } = props;
    const id = useUniqueId('RadioGroup');
    const defaultGroupName = id('');
    const name = groupName ?? defaultGroupName;
    const [value, setValue] = useMixedValue(constantValue, defaultValue, onChange);
    const onRadioChange = (newValue) => {
        setValue(newValue);
    };
    return (React.createElement(Box, { display: "inline-flex", ref: ref, role: role, ...others },
        React.createElement(RadioGroupContextProvider, { value: {
                onChange: onRadioChange,
                value,
                disabled,
                name,
            } },
            React.createElement(Stack, { flexDirection: inline ? 'row' : 'column', columnGap: "16px", rowGap: "8px", alignItems: "flex-start", flexWrap: "wrap" }, resetChildrenStatus(children, value)))));
});
export default RadioGroup;
